import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

function Sidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const handleNavigate = (path) => {
    // Scroll to top immediately for mobile compatibility
    window.scrollTo(0, 0);
    if (document.documentElement) {
      document.documentElement.scrollTop = 0;
    }
    if (document.body) {
      document.body.scrollTop = 0;
    }
    
    navigate(path);
    if (onClose) {
      onClose();
    }
    
    // Ensure scroll happens after navigation
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100);
  };

  return (
    <>
      {/* Mobile Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40 md:hidden"
          onClick={onClose}
        />
      )}
      
      {/* Sidebar */}
      <aside className={`w-64 bg-dark-surface border border-dark-border rounded-3xl p-6 shadow-xl h-fit transition-all duration-300 ${
        isOpen 
          ? 'translate-x-0 opacity-100' 
          : '-translate-x-full opacity-0 md:translate-x-0 md:opacity-100'
      }`}>
        <div className="mb-4 pb-3 border-b border-dark-border/50">
          <h2 className="text-white/60 text-xs uppercase tracking-wider font-semibold">Navigation</h2>
        </div>
        <nav className="flex flex-col gap-2">
          <div
            onClick={() => handleNavigate('/')}
            className={`rounded-2xl px-5 py-3.5 cursor-pointer transition-all duration-200 flex items-center gap-3 ${
              isActive('/')
                ? 'bg-accent-blue/20 border border-accent-blue/30 hover:bg-accent-blue/30 hover:border-accent-blue/40'
                : 'bg-dark-card/80 border border-dark-border/80 hover:bg-dark-card/90 hover:border-dark-border/90'
            }`}
          >
            <svg className="w-5 h-5 text-white/80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z" />
            </svg>
            <span className="font-medium text-sm text-white">Store</span>
          </div>
          <div
            onClick={() => handleNavigate('/bundles')}
            className={`rounded-2xl px-5 py-3.5 cursor-pointer transition-all duration-200 flex items-center gap-3 ${
              isActive('/bundles')
                ? 'bg-accent-blue/20 border border-accent-blue/30 hover:bg-accent-blue/30 hover:border-accent-blue/40'
                : 'bg-dark-card/80 border border-dark-border/80 hover:bg-dark-card/90 hover:border-dark-border/90'
            }`}
          >
            <svg className="w-5 h-5 text-white/80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
            </svg>
            <span className="font-medium text-sm text-white">Bundles</span>
          </div>
          <div
            onClick={() => handleNavigate('/creators')}
            className={`rounded-2xl px-5 py-3.5 cursor-pointer transition-all duration-200 flex items-center gap-3 ${
              isActive('/creators')
                ? 'bg-accent-blue/20 border border-accent-blue/30 hover:bg-accent-blue/30 hover:border-accent-blue/40'
                : 'bg-dark-card/80 border border-dark-border/80 hover:bg-dark-card/90 hover:border-dark-border/90'
            }`}
          >
            <svg className="w-5 h-5 text-white/80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
            </svg>
            <span className="font-medium text-sm text-white">Creators</span>
          </div>
          <div
            onClick={() => handleNavigate('/library')}
            className={`rounded-2xl px-5 py-3.5 cursor-pointer transition-all duration-200 flex items-center gap-3 ${
              isActive('/library')
                ? 'bg-accent-blue/20 border border-accent-blue/30 hover:bg-accent-blue/30 hover:border-accent-blue/40'
                : 'bg-dark-card/80 border border-dark-border/80 hover:bg-dark-card/90 hover:border-dark-border/90'
            }`}
          >
            <svg className="w-5 h-5 text-white/80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            <span className="font-medium text-sm text-white">Library</span>
          </div>
          {/* QUIZ FEATURE - Comment out this section to disable quiz */}
          {/* <div
            onClick={() => handleNavigate('/quiz')}
            className={`rounded-2xl px-5 py-3.5 cursor-pointer transition-all duration-200 ${
              isActive('/quiz')
                ? 'bg-accent-blue/20 border border-accent-blue/30 hover:bg-accent-blue/30 hover:border-accent-blue/40'
                : 'hover:bg-dark-card/50 border border-transparent'
            }`}
          >
            <span className="font-medium text-sm text-white">Discover</span>
          </div> */}
          {/* END QUIZ FEATURE */}
        </nav>
      </aside>
    </>
  );
}

export default Sidebar;
